import { Container, Typography } from '@evocolabs/orkaui'
import { Stack, useMediaQuery } from '@mui/material'
import { Professional } from '../HomePage/Professionals'
import ImageCard from '../ImageCard'
import { ContentTitle, SectionTitle } from '../title'
import { getImage } from '../HomePage/utils'

const data: { title: string; cardData: Professional[] } = {
  title: 'Meet Our Hearing Care Team',
  cardData: [
    {
      src: 'alexi.jpg',
      title: 'Dr. Alexi Silance',
      academicTitle: 'Doctor of Audiology (AuD), DNM',
      intro: `With over 30 years experience as an audiologist,
      Dr. Alexi has a passion for improving communication abilities for
      those with hearing loss. Her focus lies heavily on providing
      education about hearing aids and tinnitus management.`
    }
  ]
}
const CareTeam = (): JSX.Element => {
  const isDesktop = useMediaQuery('(min-width:1024px)')

  return (
    <Container>
      <SectionTitle>{data.title}</SectionTitle>
      {data.cardData.map(({ src, title, academicTitle, intro }) => (
        <ImageCard
          horizontal={isDesktop}
          src={getImage(src, false)}
          title={title}
          mt={{ xs: 5, dl: 8 }}
          spacing={{ xs: 3, dl: 8 }}
          key={`${title}-${isDesktop && 'horizontal'}`}
        >
          {
            <Stack spacing={{ xs: 1, dl: 2 }} flex={1}>
              <ContentTitle textAlign="left" color="black">
                {title}
              </ContentTitle>
              <Typography variant="Body2">{academicTitle}</Typography>
              <Typography variant="body2">{intro}</Typography>
            </Stack>
          }
        </ImageCard>
      ))}
    </Container>
  )
}

export default CareTeam
